














































































































































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import { VbDirectives } from '@/shared/directive/vb-directives';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import Header from './header.json';
import Summary from '../../domain/billing/entity/summary.entity';
import RowComponent from './overview-main-card-table-row.component.vue';
import OverviewCardExpandableRow from './overview-main-card-expandable-row.component.vue';

@Component({
  components: { RowComponent, VbTooltipSlot, OverviewCardExpandableRow },
  filters: {
    toCurrency: VbDirectives.toCurrency,
  },
})
export default class OverviewMainCardExpandable extends Vue {
  @Prop({
    required: true,
  })
  summary!: Summary;

  private headers: object[] = [...Header];

  @Emit('goToView')
  goToView(status: string): string {
    return status;
  }

  created() {
    this.checkHeaders();
    this.getTooltipDescription('A Faturar');
  }

  private checkHeaders(): void {
    const amount: object = this.headers.splice(1, 1)[0];
    this.headers.push(amount);
    this.headers.push(this.valueColumn);
  }

  private get valueColumn(): object {
    return {
      text: 'VALOR R$',
      align: 'right',
      value: 'value',
      width: '33%',
      sortable: false,
    }
  }

  formatValue(item: any): string {
    return VbDirectives.toCurrency(Number(item));
  }

  getTooltipDescription(name: string): string {
    const description = {
      'Não Faturados': 'Itens de contrato que apresentaram erros na '
      + 'execução do faturamento ou que estavam com suspenção de faturamento',
      'A Faturar': 'Itens de contrato ativos, de frequência mensal, que tem regras e instâncias '
      + 'aplicadas e que ainda não foram faturados para a competência escolhida na tela',
      'Pré-Faturados': 'Itens de contrato que foram pré faturados no Billing e '
      + 'ainda aguardam o faturamento no ERP',
      Faturados: 'Itens de contrato que foram faturados pelo Billing e '
      + 'tiveram emissão da Nota Fiscal no ERP',
    }
    return description[name];
  }
}
